(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    function initializeContactSpamProtection() {
    document.querySelectorAll('.contact-form__form').forEach((form) => {
      if (form.dataset.spamProtectionReady === 'true') return;

      form.dataset.spamProtectionReady = 'true';

      const openedAt = performance.now();
      const honeypot = form.querySelector('[data-contact-honeypot]');

      form.addEventListener('submit', (event) => {
        const tooFast = performance.now() - openedAt < 2500;
        const honeypotFilled = honeypot instanceof HTMLInputElement && honeypot.value.trim() !== '';

        if (!tooFast && !honeypotFilled) return;

        event.preventDefault();
        event.stopPropagation();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeContactSpamProtection, { once: true });
  } else {
    initializeContactSpamProtection();
  }
  } catch(e) { console.error(e); }
})();

})();
